import React from 'react';

import Button from '../../../../../components/Button';

interface IButtonListProps {
  isEditable: boolean;
  onClickEditBtn: () => void;
  onClickSaveConfirmBtn: () => Promise<void>;
  onClickCancelConfirmBtn: () => Promise<void>;
}
const ButtonList = ({
  isEditable,
  onClickEditBtn,
  onClickSaveConfirmBtn,
  onClickCancelConfirmBtn,
}: IButtonListProps) => {
  return (
    <div className="button-list">
      {isEditable ? (
        <>
          <Button isRadius color="primary" text="저장" onClick={onClickSaveConfirmBtn} />
          <Button isRadius text="취소" onClick={onClickCancelConfirmBtn} />
        </>
      ) : (
        <Button isRadius color="primary" text="수정" onClick={onClickEditBtn} />
      )}
    </div>
  );
};

export default ButtonList;
